import styled from 'types/theme.types';
import theme from 'constants/themes.constants';
import { WarningOutlined } from '@ant-design/icons';

export const WarningIcon = styled(WarningOutlined)`
  color: ${theme.errorRed};
`;
